import React from 'react';
import './DefaultAvatar.css';

/**
 * DefaultAvatar Component
 * Displays user initials with a gradient background when no profile image is available
 * 
 * @param {string} firstName - User's first name
 * @param {string} lastName - User's last name
 * @param {string} size - Avatar size: 'xs' (24px), 'sm' (32px), 'md' (40px), 'lg' (60px), 'xl' (80px), 'xxl' (120px), 'full' (fills container)
 * @param {string} className - Additional CSS classes
 */
const DefaultAvatar = ({ firstName, lastName, size = 'md', className = '' }) => {
  // Get initials from name
  const getInitials = () => {
    const first = firstName?.charAt(0)?.toUpperCase() || '';
    const last = lastName?.charAt(0)?.toUpperCase() || '';
    return first + last || '?';
  };

  // Generate consistent color based on name
  const getColorIndex = () => {
    const name = `${firstName || ''}${lastName || ''}`.toLowerCase();
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return Math.abs(hash % 8); // 8 different color schemes
  };

  return (
    <div className={`default-avatar default-avatar-${size} color-${getColorIndex()} ${className}`}>
      <span className="avatar-initials">{getInitials()}</span>
    </div>
  );
};

export default DefaultAvatar;
